import { Badge } from '@mantine/core';
import { VACANCY_STATUS_MODEL } from '../constants';
import commonStyles from '../vacancyStatus.module.scss';

type VacancyStatusBadgeProps = {
  status?: string;
};

export const VacancyStatusBadge = ({ status }: VacancyStatusBadgeProps) => {
  if (!status) {
    return null;
  }

  switch (status) {
    case VACANCY_STATUS_MODEL.NEW:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusBadge} ${commonStyles.vacancyStatusNew}`}
        >
          Новая
        </Badge>
      );
    case VACANCY_STATUS_MODEL.IN_PROGRESS:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusBadge} ${commonStyles.vacancyStatusInProgress}`}
        >
          Идёт подбор
        </Badge>
      );
    case VACANCY_STATUS_MODEL.SELECTION_SUSPENDED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusBadge} ${commonStyles.vacancyStatusSuspended}`}
        >
          Подбор приостановлен
        </Badge>
      );
    case VACANCY_STATUS_MODEL.SELECTION_COMPLETED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusBadge} ${commonStyles.vacancyStatusCompleted}`}
        >
          Подбор выполнен
        </Badge>
      );
    case VACANCY_STATUS_MODEL.SELECTION_CANCELLED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusBadge} ${commonStyles.vacancyStatusCancelled}`}
        >
          Подбор отменен
        </Badge>
      );
    case VACANCY_STATUS_MODEL.ARCHIVED:
      return (
        <Badge
          className={`${commonStyles.vacancyStatus} ${commonStyles.vacancyStatusBadge} ${commonStyles.vacancyStatusArchived}`}
        >
          В архиве
        </Badge>
      );
    default:
      return null;
  }
};
